import OmniApiClient from "./base";

export const wholesalersApi = {
  list: (params = {}) => OmniApiClient.get("/wholesalers", { params }),
  summary: () => OmniApiClient.get("/wholesalers/summary"),
  get: (id) => OmniApiClient.get(`/wholesalers/${id}`),
  create: (payload) => OmniApiClient.post("/wholesalers", payload),
  update: (id, payload) => OmniApiClient.put(`/wholesalers/${id}`, payload),
  remove: (id) => OmniApiClient.delete(`/wholesalers/${id}`),
  addHistory: (id, payload) =>
    OmniApiClient.post(`/wholesalers/${id}/history`, payload),
};
